var _rect, _rect2, _text, _text2, _line, _circle, _circle2, _circle3, _circle4, _line2, _line3, _line4, _line5, _line6, _polygon, _circle5, _circle6, _circle7, _circle8, _circle9, _text3, _text4, _text5, _text6, _text7, _line7, _text8, _text9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlavorRadarOverlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 240,
    viewBox: "0 0 200 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 240,
    rx: 14,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 240,
    rx: 14,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 24,
    fill: "rgba(0, 0, 0, 0.5)",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textAnchor: "middle"
  }, "FLATBREAD WRAP:")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 38,
    fill: "rgba(0, 0, 0, 0.5)",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textAnchor: "middle"
  }, "FLAVOR PROFILE")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 50,
    x2: 180,
    y2: 50,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 115,
    r: 50,
    fill: "none",
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 115,
    r: 37.5,
    fill: "none",
    stroke: "rgba(0, 0, 0, 0.08)",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 115,
    r: 25,
    fill: "none",
    stroke: "rgba(0, 0, 0, 0.06)",
    strokeWidth: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 115,
    r: 12.5,
    fill: "none",
    stroke: "rgba(0, 0, 0, 0.04)",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 115,
    x2: 100,
    y2: 65,
    stroke: "rgba(0, 0, 0, 0.15)",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 115,
    x2: 147.55,
    y2: 84.55,
    stroke: "rgba(0, 0, 0, 0.15)",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 115,
    x2: 129.39,
    y2: 155.45,
    stroke: "rgba(0, 0, 0, 0.15)",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 115,
    x2: 70.61,
    y2: 155.45,
    stroke: "rgba(0, 0, 0, 0.15)",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 115,
    x2: 52.45,
    y2: 84.55,
    stroke: "rgba(0, 0, 0, 0.15)",
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100,72.5 138,91 120,150 80,150 62,91",
    fill: "rgba(51, 92, 255, 0.15)",
    stroke: "#335CFF",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 72.5,
    r: 5,
    fill: "#335CFF",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 91,
    r: 5,
    fill: "#335CFF",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 150,
    r: 5,
    fill: "#335CFF",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 150,
    r: 5,
    fill: "#335CFF",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 91,
    r: 5,
    fill: "#335CFF",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 58,
    fill: "rgba(0, 0, 0, 0.7)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    textAnchor: "middle"
  }, "SAVORY")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 88,
    fill: "rgba(0, 0, 0, 0.7)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    textAnchor: "start"
  }, "HEAT")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 168,
    fill: "rgba(0, 0, 0, 0.7)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    textAnchor: "start"
  }, "FRESH/ACID")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 168,
    fill: "rgba(0, 0, 0, 0.7)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    textAnchor: "end"
  }, "TEXTURE")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 88,
    fill: "rgba(0, 0, 0, 0.7)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    textAnchor: "end"
  }, "FRESH")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 195,
    x2: 180,
    y2: 195,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 215,
    fill: "rgba(0, 0, 0, 0.4)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: "0.08em"
  }, "TEXTURE:")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 215,
    fill: "#335CFF",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 500
  }, "Crunchy &amp; Soft Balanced")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlavorRadarOverlay);
export default __webpack_public_path__ + "static/media/flavor-radar-overlay.3dc3cec7141371f6c2292720c686a9fd.svg";
export { ForwardRef as ReactComponent };